import React, { useState, useContext, useEffect } from "react";
import "../css/Login.css";
import logo from "../img/premier_logo.png";
import backgroundImageLogin from "../img/backgroundImageLogin.png";
import loginBgImage2 from "../img/login_bg_image-2.jpg";
import brandlogoitem1 from "../img/mitsubishi_logo.png";
import cubix_logo from "../img/cubix_logo.png";

import fuso_logo from "../img/fuso_logo.png";
import hyundai_logo from "../img/hyundai_logo.png";
import Infiniti_logo from "../img/Infiniti_logo.png";
import isuzu_logo from "../img/isuzu_logo.png";
import lexus_logo from "../img/lexus_logo.png";
import mazda_logo from "../img/mazda_logo.png";
import nissan_logo from "../img/nissan_logo.png";
import peugeot_logo from "../img/peugeot_logo.png";
import renault_logo from "../img/renault_logo.png";
import toyota_logo from "../img/toyota_logo.png";

import part_1 from "../img/part_1.png";
import part_2 from "../img/part_2.png";
import part_3 from "../img/part_3.png";
import part_4 from "../img/part_4.png";
import part_5 from "../img/part_5.png";
import part_6 from "../img/part_6.png";
import part_7 from "../img/part_7.png";
import axios from "axios";
import LoadingLayout from "./LoadingLayout";
import logo_dummy from "../img/premier_logo.png";
import leftRamp from '../img/leftRamp.svg';
import CarsBelowLogin from '../img/2_cars_below_login.png'
import RightRamp from '../img/right_ramp.svg'
import Item9 from '../img/9item.png'
import Item8 from '../img/8item.png'
import Item7 from '../img/7item.png'
import Item6 from '../img/6item.png'
import Item5 from '../img/5item.png'
import Item4 from '../img/4item.png'
import Item3 from '../img/3item.png'
import Item2 from '../img/2item.png'
import Item1 from '../img/1item.png'

import Marquee from "react-fast-marquee";


import { useNavigate } from "react-router-dom";

function Login() {

  const navigate = useNavigate();

  const initialValues = {
    username: "",
    userpassword: "",
    error: "",
  };

  const [values, setValues] = useState(initialValues);

  const [companyName, setCompanyName] = useState("");


  const [loadingScreenLoginState, setLoadingScreenLoginState] = useState(false);
  const [loadingScreenState, setLoadingScreenState] = useState(false);

  const validateInput = () => {
    if (values.username.length > 0 && values.userpassword.length > 0) {
      setValues({
        ...values,
        error: "",
      });

      return true;
    } else {
      //console.log("username password empty");

      setValues({
        ...values,
        error: "Please enter valid username and password",
      });

      return false;
    }
  };

  const callLoginAPI = () => {

    if (validateInput()) {

      setLoadingScreenLoginState(true);

      let current_company = localStorage.getItem("current_company");
      let currentCompany;
      if (current_company) {
        currentCompany = JSON.parse(localStorage.getItem("current_company"));
        console.log("current_company value is  ", currentCompany);
      }

      // console.log(
      //   "validateInput success call api uname pwd is ", values.username, values.userpassword
      // );

      // const apiUrl = `${process.env.REACT_APP_BASE_URL}/validuser/${currentCompany.company_code}/${values.username}/${values.userpassword}`;

      const apiUrl = `${process.env.REACT_APP_BASE_URL}/validuser/${currentCompany.company_code}/${values.username}/${values.userpassword}`;
      axios
        .get(apiUrl)
        .then((res) => {

          setLoadingScreenLoginState(false);

          //console.log("api response ", res);

          if (res.data.length > 0) {

            document.cookie =
              "currentSatusLog=" + JSON.stringify({ isAdminLoggedIn: true, });
            document.cookie =
              "currentSatusLogUser=" + JSON.stringify({ user: values.username });

            localStorage.setItem(
              "current_company_account_number",
              JSON.stringify({ number: res.data[0].user_profile.trim() })
            );

            if (res.data[0].accessGrp != null) {
              if (res.data[0].accessGrp == "ADMIN") {

                // set user type in cookie
                document.cookie =
                  "current_company_user_type=" + JSON.stringify({ type: "ADMIN" })

              } else {
                // set user type in cookie
                document.cookie =
                  "current_company_user_type=" + JSON.stringify({ type: "" })
              }
            }


            navigate("/home")
            // reload window to make header know about cookie , before login is success
            // there is no cookie variable only after login completion cookie is set
            // so we reload , hence Header.js can get cookie variables
            window.location.reload();

          } else {
            setValues({
              ...values,
              error: "Username or password is not correct",
            });
          }
        })
        .catch((e) => {

          setLoadingScreenLoginState(false);

          //console.log("something went wrong ", e);
          setValues({
            ...values,
            error: "Something went wrong, Please try again ",
          });

        });
    } else {
      //console.log(" validateInput returned false");

      setValues({
        ...values,
        error: "Please enter all fields correctly",
      });
    }
  };

  const handleInputChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  const getCookie = (n) => {
    let a = `; ${document.cookie}`.match(`;\\s*${n}=([^;]+)`);
    return a ? a[1] : "";
  };

  useEffect(() => {





    // check if Already logged in , through cookie variables if yes go to Homepage
    // if no do nothing

    setLoadingScreenState(true);

    if (document.cookie.length != 0) {

      let previousStateOfLogin = JSON.parse(getCookie("currentSatusLog"));

      if (previousStateOfLogin.isAdminLoggedIn) {
        //console.log("inside isAdminLoggedIn protected");
        setLoadingScreenState(false);
        navigate("/home");

        // here no window reload needed because cookie value is already there 
      } else {
        setLoadingScreenState(false);

        // get company name from local storage and set in Login page
        let current_company_local = localStorage.getItem("current_company");
        let currentCompany;

        if (current_company_local) {
          currentCompany = JSON.parse(current_company_local);
          //console.log("Home page company value is  ", currentCompany);
          setCompanyName(currentCompany.company_name);
        }
      }

    } else {
      setLoadingScreenState(false);
    }

  }, [])

  return (
    <div className="Login-page-height">
      <div className="Login-logo-container">
        <img
          alt="placeholder"
          src={logo_dummy}
          className="Login-header-logo shimmer"
        />
      </div>

      <div className="Login-main-section">


        <div className="Login-main-section-content">


          {/*newDesign  */}
          <div className="LoginNew-Section">

            <div className="LoginNew-Left-Section">



              <div className="LoginNew-LeftRamp">
                <img src={leftRamp} alt="" />
              </div>

              <div className="LoginNew-Form-Content">

                <h4 className="Login-WelcomeText">
                  Welcome to Premier <br />
                  Customer Portal
                </h4>

                <form className="Login-form">
                  <input
                    type="text"
                    name="username"
                    placeholder="Username"
                    value={values.username}
                    onChange={handleInputChange}
                    className="LoginNew-Input"
                  />

                  <input
                    type="password"
                    name="userpassword"
                    placeholder="Password"
                    value={values.userpassword}
                    onChange={handleInputChange}
                    className="LoginNew-Input"
                  />
                  <input
                    type="button"
                    value="Login"
                    className="Login-submit"
                    onClick={callLoginAPI}
                  />
                  <label className="Login-form-error-label">{values.error}</label>
                </form>
              </div>


            </div>

            <div className="LoginNew-Right-Section">


              <div className="LoginNew-RightRamp">

                <img className="Item9Img floatImgs" src={Item9} alt="" />

                <img className="Item8Img floatImgs" src={Item8} alt="" />

                <img className="Item7Img floatImgs" src={Item7} alt="" />

                <img className="Item6Img floatImgs" src={Item6} alt="" />

                <img className="Item5Img floatImgs" src={Item5} alt="" />

                <img className="Item4Img floatImgs" src={Item4} alt="" />

                <img className="Item3Img floatImgs" src={Item3} alt="" />

                <img className="Item2Img floatImgs" src={Item2} alt="" />

                <img className="Item1Img floatImgs" src={Item1} alt="" />

                <img src={RightRamp} alt="" className="RightRampImg" />
              </div>


            </div>
          </div>
          {/*newDesign  */}

        </div>
      </div>

      <div className="Login-bottom-bar">

        <div className="Login-bottom-bar">
          <div className="Login-brand-list-container">
            <Marquee>
              <ul>
                <li>
                  <img alt="placeholder" src={brandlogoitem1} />
                </li>
                <li>
                  <img alt="placeholder" src={toyota_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={fuso_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={hyundai_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={Infiniti_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={isuzu_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={lexus_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={mazda_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={nissan_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={peugeot_logo} />
                </li>
                <li>
                  <img alt="placeholder" src={renault_logo} />
                </li>
              </ul>
            </Marquee>
          </div>
          <div className="Login-bottom-strip-content d-flex justify-content-end">
            {" "}
            <span>powered by </span>
            <img alt="placeholder" src={cubix_logo} />
          </div>
        </div>


      </div>

      {loadingScreenState &&
        <LoadingLayout message={{ messageFromScreen: "Checking Log Status" }} />
      }

      {
        loadingScreenLoginState &&
        <LoadingLayout message={{ messageFromScreen: "Checking input values" }} />
      }


      <img src={CarsBelowLogin} alt="" className="CarsBelowLoginImg" />


    </div>
  );
}

export default Login;
